import { useMemo } from "react";

export const useSkillDisplayNameParser = () => {
  const skillDisplayNameMap = useMemo(
    () => ({
      "CASCADING STYLE SHEETS": "CSS",
      ".NET FRAMEWORK": ".NET",
    }),
    []
  );

  const parseSkillDisplayName = useMemo(() => {
    const memo = new Map();

    return (name = "") => {
      if (memo.has(name)) return memo.get(name);

      const normalized = name.replace(/\s*\([^)]*\)/g, "").trim();
      const displayName =
        skillDisplayNameMap[normalized.toUpperCase()] || normalized;

      memo.set(name, displayName);
      return displayName;
    };
  }, [skillDisplayNameMap]);

  return parseSkillDisplayName;
};

export const useSkillDisplayName = (rawName) => {
  const parseSkillDisplayName = useSkillDisplayNameParser();
  return useMemo(
    () => parseSkillDisplayName(rawName),
    [parseSkillDisplayName, rawName]
  );
};
